import { KeyValueEntity } from './BasicEntities';

export class SkuShadeGroup extends KeyValueEntity {}
